export default {
  MODULE_NAME: 'tracking',
};
